import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera } from "lucide-react";
import { API, apiFetch } from "@/lib/api";

export const RecentPhotos = () => {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    apiFetch("/photos/recent").then((r) => setPhotos(r.photos)).catch(() => {});
  }, []);

  if (photos.length === 0) return null;

  return (
    <section className="border-t border-neutral-200 bg-neutral-50" data-testid="recent-photos">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <h2 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-neutral-900">
          <Camera className="h-5 w-5 text-[#4D7C0F]" /> Recent photos
        </h2>
        <p className="mt-1 text-sm text-neutral-500 md:text-lg">Straight from members at this month's events.</p>
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-6">
          {photos.slice(0, 12).map((p) => (
            <Link
              key={p.photo_id}
              to={`/events/${p.event_id}`}
              data-testid={`recent-photo-${p.photo_id}`}
              className="group relative overflow-hidden rounded-xl bg-neutral-200 aspect-square"
            >
              <img
                src={`${API}/photos/${p.photo_id}/image`}
                alt={p.caption || p.event_title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute inset-x-0 bottom-0 truncate bg-gradient-to-t from-black/75 to-transparent px-2 py-2 text-[11px] font-semibold text-white">
                {p.event_title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
